import { connect } from 'react-redux';
import { denormalize } from 'normalizr';

import { schema } from '../../../../../state/schema';
import {
  loadResourceNotes,
  deleteResourceNote,
} from '../../../../../state/modules/resourceNotes/actions';
import { sendMessage } from '../../../../../state/actions';
import ResourceNotesList from '../components/ResourceNotesList';

const mapStateToProps = (state, ownProps) => {
  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.resourceNotes.getIn(['pages', order, limit, page]);

  return {
    list: result
      ? result
          .map((x) => {
            return {
              key: x,
              ...denormalize(
                state.entities.getIn(['resourceNotes', x]),
                schema.resourceNote,
                state.entities.toJS()
              ),
            };
          })
          .toArray()
          .map((x) => {
            // flatten some nested objects to make table easier to work with
            return {
              partnership_name: x?.resource?.partnership?.name ?? '',
              partnership_plan: x?.resource?.partnership?.plan?.name ?? '',
              profile_id: x.profile ? x.profile.id : '',
              profile_username:
                x.profile && x.profile.user ? x.profile.user.username : '',
              ...x,
            };
          })
      : [],
    isLoading: state.resourceNotes.get('isLoading'),
    total: state.resourceNotes.get('total'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadResourceNotes(page, limit, order, filter, cb));
    },
    remove: (id, cb) => {
      dispatch(deleteResourceNote(id, cb));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  };
};

const ResourceNotesListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResourceNotesList);

export default ResourceNotesListContainer;
